




























































































import { Vue, Component, Prop } from 'nuxt-property-decorator'
import {
  defineComponent,
  useStore,
  computed,
  SetupContext,
} from '@nuxtjs/composition-api'
import { TypePages } from '../../contracts/PageTypes'
import Link from '@/components/Link.vue'
import {
  ScheduleMicroformat,
  AdaptedOffice,
} from '@/apollo/adapters/modules/officeAdapter'

@Component({})
class BlockOffice extends Vue {
  @Prop({ default: '' }) readonly title: string = ''
  @Prop({ default: false }) readonly popup: boolean = false
  @Prop({ default: '' }) readonly address: string = ''
  @Prop({ default: () => [] }) readonly coords: [] = []
  @Prop({ default: '' }) readonly office: AdaptedOffice
  @Prop({ default: '' }) readonly selectedOffice: AdaptedOffice
  @Prop({ default: '' }) readonly tel: string = ''
  @Prop({
    default: () => ({
      title: '',
      text: '',
    }),
  })
  readonly warning: Object = {}

  @Prop({
    default: () => ({
      title: '',
      text: '',
    }),
  })
  readonly workSchedule: Object = {}

  @Prop({
    default: () => ({
      title: '',
      text: '',
    }),
  })
  @Prop({ default: [] })
  readonly workScheduleMicroformat: ScheduleMicroformat[] = []

  @Prop({ default: '' }) readonly officeFullUrlPath: string = ''
  @Prop({ default: () => {} })
  readonly wayToOffice: Object = {}

  @Prop({
    default: () => ({
      title: '',
      tags: [],
    }),
  })
  readonly services: Object = {}

  static options: any
}

export default defineComponent({
  name: 'BlockOffice',
  components: { Link },
  props: BlockOffice.options.props,
  setup(props: BlockOffice, { emit, root }: SetupContext) {
    const store = useStore()
    const togglePopup = () =>
      store.commit('popupBuyOnline/SET_SHOW_POPUP', true)
    const computedLink = computed(() => {
      return props.coords
        ? `https://yandex.ru/maps/?rtext=~${props.coords.join('%2C')}`
        : null
    })
    // TODO Добавить верный адрес к офису
    const microformat = {
      '@context': 'http:\\/\\/schema.org\\/',
      '@type': 'LocalBusiness',
      name: props.title,
      telephone: props.tel,
      url: props.officeFullUrlPath,
      logo: 'https://www.rgs.ru/upload/medialibrary/998/logo_1200_1.jpg',
      image: 'https://www.rgs.ru/upload/medialibrary/998/logo_1200_1.jpg',
      brand: {
        '@type': 'Brand',
        name: props.title,
      },
      address: {
        '@type': 'PostalAddress',
        name: props.address,
      },
      openingHoursSpecification: props.workScheduleMicroformat,
    }

    const fullUrl = computed(() => {
      const fromPath = root.context.from?.path

      if (fromPath) {
        return fromPath
      }
      if (!props.office) {
        return '/'
      }
      const uniquePageUrls = store.getters['settings/uniquePageUrls']
      return uniquePageUrls[TypePages.offices]
    })

    const returnButtonProps = computed(() =>
      props.office
        ? {
            name: 'Link',
            is: 'Link',
            class: 'link--basic arrow-left',
            url: fullUrl.value,
          }
        : {
            is: 'button',
            name: 'button',
            class: 'return-button link--basic arrow-left',
          }
    )

    const returnButtonEvents = computed(() =>
      props.office ? {} : { click: () => emit('show-office-list') }
    )

    return {
      fullUrl,
      togglePopup,
      computedLink,
      microformat,
      returnButtonProps,
      returnButtonEvents,
    }
  },
})
